// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__-z23A"};